import React, { useRef } from "react";
import axios from "src/config/axios";
import { Button, Modal } from "react-bootstrap";
import { Form, Formik } from "formik";
import FormInputText from "src/components/Forms/FormInputText";

const EditOccupiedUnitsDialog = ({ report, handleClose, handleSuccess }) => {
  function validate(values) {
    const errors = {};

    if (
      values.occupied_units === "" ||
      values.occupied_units === null ||
      values.occupied_units === undefined
    ) {
      errors.occupied_units = "Belegte Einheiten darf nicht leer sein.";
    } else if (Number(values.occupied_units) < 0) {
      errors.occupied_units =
        "Belegte Einheiten muss größer oder gleich 0 sein.";
    }

    return errors;
  }

  function submit(values, { setSubmitting, setErrors }) {
    setSubmitting(true);
    axios
      .put(`/api/v1/local_tax_daily_reports/${report.id}.json`, {
        local_tax_daily_report: {
          occupied_units: Number(values.occupied_units),
        },
      })
      .then(({ data }) => {
        handleSuccess(data);
      })
      .catch((error) => {
        if (error.response?.data) {
          setErrors(error.response.data);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  }

  const formRef = useRef();

  function handleSubmit() {
    formRef.current.handleSubmit();
  }

  return (
    <Modal show={true} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Belegte Einheiten bearbeiten</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          innerRef={formRef}
          initialValues={{
            occupied_units: report.occupied_units ?? 0,
          }}
          validate={validate}
          onSubmit={submit}
        >
          {({ isSubmitting }) => (
            <Form autoComplete="false">
              <FormInputText
                name="occupied_units"
                label="Belegte Einheiten"
                type="number"
                min={0}
                step={1}
                disabled={isSubmitting}
              />
            </Form>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Schließen
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Speichern
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditOccupiedUnitsDialog;
